import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentProposal } from 'Store/booking/booking.selector';
import { PaymentInfoContext } from 'Components/widgets/payment-info/PaymentInfoContext';

export const useCustomerId = (customerNeolaneId?: string) => {
  const { selectedHouseholdIndex = 0 } = useContext(PaymentInfoContext);
  const selectedProposal = useSelector(getCurrentProposal);
  return (
    selectedProposal?.households?.[selectedHouseholdIndex]?.attendees?.[0]?.customerId ||
    customerNeolaneId ||
    ''
  );
};
